enum IRelocationPreference {
  NO_RELOCATION = 'NoRelocation',
  WITHIN_STATE = 'WithinState',
  WITHIN_COUNTRY = 'WithinCountry',
  ANYWHERE = 'AnyWhere',
  NONE = 'None',
}

export default IRelocationPreference;
